/**
 * The data Worker's listing-status route as VIP asks it: which held codes the
 * market no longer trades (WORK.md item 44 step 7, phase B), and each code's
 * quote currency (audit MONEY-9). The app's holdings read it
 * (app/src/lib/listingStatus.ts), and so does the shared-link page
 * (functions/shared/[token].ts).
 *
 * The Worker refuses a whole request that names one code over 40 characters,
 * so a single self-priced code cost the book every status and every quote
 * unit: the pension's registered codes run to 47, and on 2026-11-01 its
 * holdings read "Listing status unavailable" with no series put into its
 * trades' unit (audit MONEY-27). A `$` code is cash, which the route never
 * knows. Neither is asked; neither has a status or a quote currency.
 */

export const STATUS_ROUTE = '/api/symbols/status';
/** The most codes the route reads a request (the Worker's MAX_CODES). */
export const STATUS_MAX_CODES = 400;
/** The longest code the route reads; a request naming a longer one is refused whole. */
export const STATUS_MAX_CODE_LEN = 40;

/** The codes to ask, each once and trimmed: no cash code, no code the route refuses. */
export function statusCodes(codes: Iterable<string | null | undefined>): string[] {
  const out = new Set<string>();
  for (const raw of codes) {
    const c = typeof raw === 'string' ? raw.trim() : '';
    if (c && !c.startsWith('$') && c.length <= STATUS_MAX_CODE_LEN) out.add(c);
  }
  return [...out];
}
